<template>
    <div class="vowel-container" v-bind:style="{ width: computedWidth, minWidth: computedWidth }">
        <div id="vowel-group" class="group vowel-group">
            <Card v-for="vowel in vowels" :key="vowel.symbol" v-bind="vowel" v-bind:id="vowel.symbol" :cols="cols" />
        </div>
    </div>
</template>

<script>

import Card from "./Card.vue"

export default {
    name: 'Vowels',
    components: {
        Card
    },
    data: function() {
        return {
            "ready": false,
            "redrawing": false,
            "vowels": [
                {
                    "symbol": "iː",
                    "exampleword": "sh<span style='color: #ffde59'>ee</span>p",
                    "delimiter": "slash",
                    "imagefile": "/assets/vowels/iː.png",
                    "soundfile": "/assets/vowels/iː.m4a",
                    "colOrder2": "0",
                    "colOrder3": "0",
                    "colOrder4": "0",
                    "colOrder5": "0",
                    "colOrder6": "0",
                    "colOrder7": "0",
                },
                {
                    "symbol": "ɪ",
                    "delimiter": "slash",
                    "exampleword": "sh<span style='color: #ffde59'>i</span>p",
                    "imagefile": "/assets/vowels/ɪ.png",
                    "soundfile": "/assets/vowels/ɪ.m4a",
                    "colOrder2": "6",
                    "colOrder3": "1",
                    "colOrder4": "1",
                    "colOrder5": "1",
                    "colOrder6": "1",
                    "colOrder7": "1",
                },
                {
                    "symbol": "uː",
                    "delimiter": "slash",
                    "exampleword": "s<span style='color: #ffde59'>ui</span>t",
                    "imagefile": "/assets/vowels/uː.png",
                    "soundfile": "/assets/vowels/uː.m4a",
                    "colOrder2": "18",
                    "colOrder3": "2",
                    "colOrder4": "3",
                    "colOrder5": "4",
                    "colOrder6": "3",
                    "colOrder7": "3",
                },
                {
                    "symbol": "e",
                    "delimiter": "slash",
                    "exampleword": "b<span style='color: #ffde59'>e</span>d",
                    "imagefile": "/assets/vowels/e.png",
                    "soundfile": "/assets/vowels/e.m4a",
                    "colOrder2": "2",
                    "colOrder3": "3",
                    "colOrder4": "3",
                    "colOrder5": "5",
                    "colOrder6": "6",
                    "colOrder7": "7",
                },
                {
                    "symbol": "ʊ",
                    "delimiter": "slash",
                    "exampleword": "b<span style='color: #ffde59'>oo</span>k",
                    "imagefile": "/assets/vowels/ʊ.png",
                    "soundfile": "/assets/vowels/ʊ.m4a",
                    "colOrder2": "16",
                    "colOrder3": "4",
                    "colOrder4": "2",
                    "colOrder5": "2",
                    "colOrder6": "2",
                    "colOrder7": "2",
                },
                {
                    "symbol": "ɔː",
                    "delimiter": "slash",
                    "exampleword": "l<span style='color: #ffde59'>aw</span>",
                    "imagefile": "/assets/vowels/ɔː.png",
                    "soundfile": "/assets/vowels/ɔː.m4a",
                    "colOrder2": "20",
                    "colOrder3": "5",
                    "colOrder4": "7",
                    "colOrder5": "9",
                    "colOrder6": "9",
                    "colOrder7": "10",
                },
                {
                    "symbol": "æ",
                    "delimiter": "slash",
                    "exampleword": "c<span style='color: #ffde59'>a</span>t",
                    "imagefile": "/assets/vowels/æ.png",
                    "soundfile": "/assets/vowels/æ.m4a",
                    "colOrder2": "4",
                    "colOrder3": "6",
                    "colOrder4": "8",
                    "colOrder5": "10",
                    "colOrder6": "12",
                    "colOrder7": "14",
                },
                {
                    "symbol": "ə",
                    "delimiter": "slash",
                    "exampleword": "butt<span style='color: #ffde59'>er</span>",
                    "imagefile": "/assets/vowels/ə.png",
                    "soundfile": "/assets/vowels/ə.m4a",
                    "colOrder2": "8",
                    "colOrder3": "7",
                    "colOrder4": "5",
                    "colOrder5": "6",
                    "colOrder6": "7",
                    "colOrder7": "8",
                },
                {
                    "symbol": "ɒ",
                    "delimiter": "slash",
                    "exampleword": "h<span style='color: #ffde59'>o</span>t",
                    "imagefile": "/assets/vowels/ɒ.png",
                    "soundfile": "/assets/vowels/ɒ.m4a",
                    "colOrder2": "22",
                    "colOrder3": "8",
                    "colOrder4": "11",
                    "colOrder5": "14",
                    "colOrder6": "15",
                    "colOrder7": "17",
                },
                {
                    "symbol": "eɪ",
                    "delimiter": "slash",
                    "exampleword": "sn<span style='color: #ffde59'>ai</span>l",
                    "imagefile": "/assets/vowels/eɪ.png",
                    "soundfile": "/assets/vowels/eɪ.m4a",
                    "colOrder2": "1",
                    "colOrder3": "9",
                    "colOrder4": "12",
                    "colOrder5": "15",
                    "colOrder6": "4",
                    "colOrder7": "4",
                },
                {
                    "symbol": "ɜː",
                    "delimiter": "slash",
                    "exampleword": "t<span style='color: #ffde59'>ur</span>n",
                    "imagefile": "/assets/vowels/ɜː.png",
                    "soundfile": "/assets/vowels/ɜː.m4a",
                    "colOrder2": "10",
                    "colOrder3": "10",
                    "colOrder4": "6",
                    "colOrder5": "11",
                    "colOrder6": "13",
                    "colOrder7": "15",
                },
                {
                    "symbol": "ʊə",
                    "delimiter": "slash",
                    "exampleword": "<span style='color: #ffde59'>Eu</span>rope",
                    "imagefile": "/assets/vowels/ʊə.png",
                    "soundfile": "/assets/vowels/ʊə.m4a",
                    "colOrder2": "11",
                    "colOrder3": "11",
                    "colOrder4": "14",
                    "colOrder5": "22",
                    "colOrder6": "5",
                    "colOrder7": "5",
                },
                {
                    "symbol": "eə",
                    "delimiter": "slash",
                    "exampleword": "c<span style='color: #ffde59'>are</span>",
                    "imagefile": "/assets/vowels/eə.png",
                    "soundfile": "/assets/vowels/eə.m4a",
                    "colOrder2": "5",
                    "colOrder3": "12",
                    "colOrder4": "16",
                    "colOrder5": "20",
                    "colOrder6": "10",
                    "colOrder7": "11",
                },
                {
                    "symbol": "ʌ",
                    "delimiter": "slash",
                    "exampleword": "d<span style='color: #ffde59'>u</span>ck",
                    "imagefile": "/assets/vowels/ʌ.png",
                    "soundfile": "/assets/vowels/ʌ.m4a",
                    "colOrder2": "14",
                    "colOrder3": "13",
                    "colOrder4": "9",
                    "colOrder5": "7",
                    "colOrder6": "8",
                    "colOrder7": "9",
                },
                {
                    "symbol": "əʊ",
                    "delimiter": "slash",
                    "exampleword": "sn<span style='color: #ffde59'>ow</span>",
                    "imagefile": "/assets/vowels/əʊ.png",
                    "soundfile": "/assets/vowels/əʊ.m4a",
                    "colOrder2": "7",
                    "colOrder3": "14",
                    "colOrder4": "18",
                    "colOrder5": "17",
                    "colOrder6": "11",
                    "colOrder7": "12",
                },
                {
                    "symbol": "ɪə",
                    "delimiter": "slash",
                    "exampleword": "b<span style='color: #ffde59'>eer</span>",
                    "imagefile": "/assets/vowels/ɪə.png",
                    "soundfile": "/assets/vowels/ɪə.m4a",
                    "colOrder2": "3",
                    "colOrder3": "15",
                    "colOrder4": "13",
                    "colOrder5": "16",
                    "colOrder6": "16",
                    "colOrder7": "18",
                },
                {
                    "symbol": "ɑː",
                    "delimiter": "slash",
                    "exampleword": "c<span style='color: #ffde59'>ar</span>",
                    "imagefile": "/assets/vowels/ɑː.png",
                    "soundfile": "/assets/vowels/ɑː.m4a",
                    "colOrder2": "12",
                    "colOrder3": "16",
                    "colOrder4": "10",
                    "colOrder5": "12",
                    "colOrder6": "14",
                    "colOrder7": "16",
                },
                {
                    "symbol": "aʊ",
                    "delimiter": "slash",
                    "exampleword": "c<span style='color: #ffde59'>ow</span>",
                    "imagefile": "/assets/vowels/aʊ.png",
                    "soundfile": "/assets/vowels/aʊ.m4a",
                    "colOrder2": "13",
                    "colOrder3": "17",
                    "colOrder4": "15",
                    "colOrder5": "3",
                    "colOrder6": "17",
                    "colOrder7": "19",
                },
                {
                    "symbol": "aɪ",
                    "delimiter": "slash",
                    "exampleword": "<span style='color: #ffde59'>eye</span>",
                    "imagefile": "/assets/vowels/aɪ.png",
                    "soundfile": "/assets/vowels/aɪ.m4a",
                    "colOrder2": "9",
                    "colOrder3": "19",
                    "colOrder4": "17",
                    "colOrder5": "27",
                    "colOrder6": "22",
                    "colOrder7": "6",
                },
                {
                    "symbol": "ɔɪ",
                    "delimiter": "slash",
                    "exampleword": "b<span style='color: #ffde59'>oy</span>",
                    "imagefile": "/assets/vowels/ɔɪ.png",
                    "soundfile": "/assets/vowels/ɔɪ.m4a",
                    "colOrder2": "15",
                    "colOrder3": "20",
                    "colOrder4": "19",
                    "colOrder5": "8",
                    "colOrder6": "23",
                    "colOrder7": "13",
                }
            ]
        }
    },
    mounted: function() {
      this.ready = true;
      var self = this;
      setTimeout(function() {
          self.injectFor(self.$attrs.cols);
      }, 100);
  },
  computed: {
    cols: function () {
        if (!this.redrawing && this.ready) {
            this.injectFor(this.$attrs.cols);
        }
        return this.$attrs.cols;
    },
    computedWidth: function () {
      return (this.$attrs.cols * 1 + 1) * 190 + (5 * 2) + "px";
    },
  },
  methods: {
    genBlank: function() {
        var blank = document.createElement("div");
        blank.classList.add("card");
        blank.classList.add("intentional-blank-vowel");
        blank.style.width = "190px";
        blank.style.height = "190px";
        blank.style.display = "block";
        blank.style.margin = "5px";
        blank.style.backgroundColor = "transparent";
        blank.innerHTML = "";
        return blank;
    },
    injectBlankCardAtGlyph: function (glyph = "", position = "before") {
      // position=['before','after']
      // This is a pure DOM call; we don't need to touch the `self` reference in here so don't redeclare it.
      //("Appending a blank card " + position + " '" + glyph + "'...");

      // Generate a blank card element with appropriate classes
      var blank = this.genBlank();

      const target = document.getElementById(glyph);
      //console.log(target);
      //console.log("order = ", Number(target.style.order));

      var targetColOrderRef = this.vowels.find(obj => {
        return obj["symbol"] === glyph
      });
      //console.log("TCORn ", targetColOrderRef);

      var targetColOrder = Number(targetColOrderRef["colOrder" + this.cols]);

      if (target != null) {
        if (position == "before") {
          blank.style.order = targetColOrder - 1;
          target.insertAdjacentElement("beforebegin", blank);
        } else if (position == "after") {
          blank.style.order = targetColOrder + 1;
          target.insertAdjacentElement("afterend", blank);
        } else if (position.substr(0,4) == "pack") { // pack onto the top of the heap, or place N before {glyph}
          //console.log("packd");
          var pack_iterations = Number(position.split(",")[1]);
          var packblanks = [];

          for(var i = 0; i < pack_iterations; i++) {
              var theIblank = this.genBlank();
              theIblank.style.order = targetColOrder-Math.abs(i-1);
              packblanks.unshift(theIblank);
          }

          packblanks.sort(function(a,b){return Number(a.style.order) - Number(b.style.order);}).forEach(e => {
              //console.log("beforebegin");
              target.insertAdjacentElement("beforebegin", e);
          });

        } else if (position.substr(0,4) == "push") { // push onto the end of the heap, or place N after {glyph}
          //console.log("pushd");
          var push_iterations = Number(position.split(",")[1]);
          var pushblanks = [];

          for(var j = 0; j < push_iterations; j++) {
              var theJblank = this.genBlank();
              theJblank.style.order = targetColOrder+Math.abs(j+1);
              pushblanks.push(theJblank); //this is ugh-ly; I hate no-redefine
          }

          pushblanks.sort(function(a,b){return Number(b.style.order) - Number(a.style.order);}).forEach(e => {
              //console.log("insertafterend");
              target.insertAdjacentElement("afterend", e);
          });

        } else {
          //console.log("big sad default");
          blank.style.order = targetColOrder - 1;
          target.insertAdjacentElement("beforebegin", blank);
        }
      }
    },
    clearBlanks: function () {
      //console.log("clearblanks");
      var container = document.getElementById("vowel-group");
      if (container != null) {
        var empties = container.getElementsByClassName("intentional-blank-vowel");
        //console.log("remove vowels");
        if (empties.length > 0) {
          while(empties[0]) {
              empties[0].parentNode.removeChild(empties[0]); // This was fucking the whole goddamned thing up.  Who knew getElementsByClassName wasn't safe to use in an iterable SINCE IT'S A LIVE DOM REFERENCE
          }
        }
      }
    },
    injectFor: function (cols = 2) {
      if (cols == 0) {
        cols = 2;
      }
      if(this.ready == false) {
          //console.log("not ready; returning.");
          return;
      }

      //console.log(!this.redrawing);
      if (!this.redrawing) {
        this.redrawing = true;
        //console.log("redrawing!");

        // Cleared out the placeholder shunt elements.  Now reinject for a screen redraw.

        if (cols == 2) {
          //
          this.clearBlanks();
          this.injectBlankCardAtGlyph("ʊ", "push,1");
          this.injectBlankCardAtGlyph("uː", "push,1");
          this.injectBlankCardAtGlyph("ɔː", "push,1");
          this.injectBlankCardAtGlyph("ɒ", "push,1");
          this.redrawing = false;
        } else if (cols == 3) {
          //
          this.clearBlanks();
          this.injectBlankCardAtGlyph("aɪ", "pack,1");
          this.redrawing = false;
        } else if (cols == 4) {
          this.clearBlanks();
          // DO NOTHING!!! :D
          this.redrawing = false;
        } else if (cols == 5) {
          //
          this.clearBlanks();

          //this.injectBlankCardAtGlyph("", "");
          this.injectBlankCardAtGlyph("ɑː", "push,1");

          this.injectBlankCardAtGlyph("eə", "pack,2");
          this.injectBlankCardAtGlyph("eə", "push,1");

          this.injectBlankCardAtGlyph("ʊə", "push,2");

          this.injectBlankCardAtGlyph("aɪ", "pack,2");
          this.injectBlankCardAtGlyph("aɪ", "push,2");





          this.redrawing = false;
        } else if (cols == 6) {
          //
          this.clearBlanks();

          this.injectBlankCardAtGlyph("aɪ", "pack,4");

          this.redrawing = false;
        } else if (cols == 7) {
          //
          this.clearBlanks();

          this.injectBlankCardAtGlyph("aʊ", "push,1");

          this.redrawing = false;
        }
      }
      //console.log("injectfor", cols);
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .vowel-container  h3 {
        margin: 40px 0 0;
    }
    .vowel-container  ul {
        list-style-type: none;
        padding: 0;
    }
    .vowel-container  li {
        display: inline-block;
        margin: 0 10px;
    }
    .vowel-container  a {
        color: #42b983;
    }

    .vowel-container {
        display: block;
        width: 100%;
        margin: 0 auto;
    }

    .vowel-container .intentional-blank {
      color: coral;
    }

    .vowel-container .vowel-group {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        /*margin: 0 auto;*/
    }
</style>
